import(/* webpackMode: "eager" */ "/app/node_modules/next-i18n-router/dist/client/useCurrentLocale.js");
;
import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/app/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["HeroSectionClient"] */ "/app/src/app/[locale]/helpdesk/(default)/_components/HeroSection/HeroSectionClient.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/[locale]/helpdesk/(default)/_components/PopularSection/PopularContent.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/helpdesk/(default)/_components/ResourcesSection/ResourcesSection.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/helpdesk/(default)/_components/ResourcesSection/ResourceCard.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/icons/svg/community.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/svg/resources-api-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/svg/resources-blog-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/svg/resources-documentation-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/svg/resources-graduate-icon.svg");
;
import(/* webpackMode: "eager" */ "/app/src/icons/svg/resources-templates-icon.svg");
;
import(/* webpackMode: "eager", webpackExports: ["I18nLink"] */ "/app/src/lib/components/I18nLink/I18nLink.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ContactSupportSection"] */ "/app/src/shared/ContactSupportSection/ContactSupportSection.tsx");
